// utils/crisp.ts
// Crisp chat loader for a SPA. We intentionally load it dynamically so we can
// enable it only on selected routes (e.g. marketing pages) instead of globally.

declare global {
  interface Window {
    $crisp?: any[];
    CRISP_WEBSITE_ID?: string;
  }
}

const CRISP_SCRIPT_ID = 'crisp-chat-script';

function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function isCrispLoaded() {
  if (!isBrowser()) return false;
  return Boolean(document.getElementById(CRISP_SCRIPT_ID));
}

export function loadCrisp(websiteId: string) {
  if (!isBrowser()) return;
  if (!websiteId) return;

  // Initialize global vars expected by Crisp.
  window.$crisp = window.$crisp || [];
  window.CRISP_WEBSITE_ID = websiteId;

  // Avoid injecting the script multiple times.
  if (isCrispLoaded()) {
    // If the script is already there, just ensure the widget is visible.
    try {
      window.$crisp?.push(['do', 'chat:show']);
    } catch {
      // no-op
    }
    return;
  }

  const s = document.createElement('script');
  s.id = CRISP_SCRIPT_ID;
  s.src = 'https://client.crisp.chat/l.js';
  s.async = true;
  document.getElementsByTagName('head')[0]?.appendChild(s);
}

export function hideCrisp() {
  if (!isBrowser()) return;

  try {
    window.$crisp?.push(['do', 'chat:hide']);
  } catch {
    // If Crisp isn't ready yet, ignore.
  }
}

